import "../css/admin.css"
import { Icon } from "@iconify/react";
import ApexCharts from "apexcharts"
import { useState } from "react";
import useFirebaseStore from "../store/firebasestore";
import axios from "axios";
import { useEffect,useRef } from "react";
import useGenStore from "../store/genstore";

function Analytics(){
const adminGraph = useRef(null)
const chartRef = useRef(null)
            const clearedOrders = useFirebaseStore((s)=>s.clearedOrders)
            const totalUser = useGenStore((s)=>s.totalUser)
            const totalEarnings = useGenStore((s)=>s.totalEarnings)
                const [credits, setCredits] = useState(0)
            
            const monthlySales = useGenStore((s)=>s.monthlySales)
const checkSMSBalance = async () => {
    try {
        const resp = await axios.post("https://schoollabelbackend-iwy4.onrender.com/smsBalance", {
            // If your endpoint requires any data in the body, add it here.
            // If not, you can leave it as an empty object, or remove the second argument entirely.
        })
        
        // Axios automatically parses JSON, so you can use resp.data
        setCredits(resp.data.credit)
        return resp.data // Optional: return the data if you need to use it elsewhere
        
    } catch (error) {
        console.log(error)
        // Optional: handle the error gracefully
    }

}

useEffect(()=>{
    checkSMSBalance()

const chartData = [
 { month: "Jan", sales: monthlySales.Jan || 0 },
 { month: "Feb", sales: monthlySales.Feb || 0 },
 { month: "Mar", sales: monthlySales.Mar || 0 },
 { month: "Apr", sales: monthlySales.Apr || 0 },
 { month: "May", sales: monthlySales.May || 0 },
 { month: "Jun", sales: monthlySales.Jun || 0 },
 { month: "Jul", sales: monthlySales.Jul || 0 },
 { month: "Aug", sales: monthlySales.Aug || 0 },
 { month: "Sep", sales: monthlySales.Sep || 0 },
 { month: "Oct", sales: monthlySales.Oct || 0 },
 { month: "Nov", sales: monthlySales.Nov || 0 },
 { month: "Dec", sales: monthlySales.Dec || 0 }
];

const options = {

series:[{
name:'Sales',
data: chartData.map(item => item.sales)
}],

colors:["#25A9E1"],

chart:{
height:"80%",
type:'area'
},

dataLabels:{
enabled:false
},

stroke:{
curve:"smooth",
width:1
},

grid:{
show:true
},

legend:{
show:false
},

xaxis:{
categories: chartData.map(item => item.month)
},

yaxis:{
title:{
text:"Sales - Thousands"
},
// labels:{
// formatter:(value)=> value + "K"
// }
},

// tooltip:{
// y:{
// formatter:(val)=> val + "K Sales"
// }
// }

}

if(adminGraph.current){
chartRef.current = new ApexCharts(adminGraph.current, options)
chartRef.current.render()
}

return () => {
if(chartRef.current){
chartRef.current.destroy()
}
}

},[monthlySales])
function formatNumber(num) {
  const format = (n) => Number.isInteger(n) ? n : n.toFixed(1);

  if (num >= 1_000_000_000) return format(num / 1_000_000_000) + "B";
  if (num >= 1_000_000) return format(num / 1_000_000) + "M";
  if (num >= 1_000) return format(num / 1_000) + "K";
  return num;
}
    return(
        <div className="AnalyticsWrapper">
           <div className="analyticsTop">
            <div className="analyticsTopCard atcCard4">
                <div className="analyticsTopCardCont">
                    <div className="atcTop">
                        <div className="atcIcon">
                            <Icon icon="solar:wallet-money-bold-duotone" className="faIcon" />
                        </div>
                        <div className="atcMiniDirection">
                            <Icon icon="solar:alt-arrow-up-bold" className="faIcon UpIcon"/>
                            <span>Up</span>
                        </div>
                    </div>
                    <div className="atcBtm">
                        <span>Ksh. {formatNumber(totalEarnings)}</span>
                        <span>Earnings</span>
                    </div>
                </div>
            </div>
            <div className="analyticsTopCard atcCard3">
                <div className="analyticsTopCardCont">
                    <div className="atcTop">
                        <div className="atcIcon">
                            <Icon icon="solar:users-group-rounded-bold-duotone" className="faIcon" />
                        </div>
                        <div className="atcMiniDirection">
                            <Icon icon="solar:alt-arrow-up-bold" className="faIcon UpIcon"/>
                            <span>Up</span>
                        </div>
                    </div>
                    <div className="atcBtm">
                        <span>{totalUser}</span>
                        <span>Total Users</span>
                    </div>
                </div>
            </div>

            <div className="analyticsTopCard atcCard1">
                <div className="analyticsTopCardCont">
                    <div className="atcTop">
                        <div className="atcIcon">
                            <Icon icon="solar:chat-line-bold" className="faIcon" />
                        </div>
                        <div className="atcMiniDirection">
                            <Icon icon="solar:alt-arrow-down-bold" className="faIcon DownIcon"/>
                            <span className="DownIconTxt">Down</span>
                        </div>
                    </div>
                    <div className="atcBtm">
                        <span>{credits}</span>
                        <span>SMS Tokens</span>
                    </div>
                </div>
            </div>
            <div className="analyticsTopCard atcCard2">
                <div className="analyticsTopCardCont">
                    <div className="atcTop">
                        <div className="atcIcon">
                            <Icon icon="solar:bag-check-bold" className="faIcon" />
                        </div>
                        <div className="atcMiniDirection">
                            <Icon icon="solar:alt-arrow-up-bold" className="faIcon UpIcon"/>
                            <span>Up</span>
                        </div>
                    </div>
                    <div className="atcBtm">
                        <span>{clearedOrders.length}</span>
                        <span>Completed Orders</span>
                    </div>
                </div>
            </div>
                
           </div>
           <div className="analyticsBtm">
            <div className="analyticsTittle">
                <p>Your Earnings</p>
            </div>
               <div className="analyticsGraph" ref={adminGraph}>

               </div>
           </div>
        </div>
    )
}
export default Analytics;